import { shallowMount } from "@vue/test-utils";
import Oferta from "@/views/Oferta";
import bus from "@/bus";

describe("Oferta component", () => {
  let wrapper;

  beforeEach(() => {
    jest.clearAllMocks();
    wrapper = shallowMount(Oferta);
    wrapper.vm.$router.push.mockClear();
  });

  it("Renders del component Oferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("continuar emite analytics:event y navega al siguiente paso", () => {
    const emitSpy = jest.spyOn(bus, "$emit");
    wrapper.vm.currentView = { config: { analyticsName: "oferta" } };

    wrapper.vm.continuar();

    expect(emitSpy).toHaveBeenCalledWith("analytics:event", {
      event: "interaction_link",
      eventData: {
        name: "continuar",
        level2: "oferta",
        level3: "paquete"
      }
    });
    expect(wrapper.vm.$router.push).toHaveBeenCalledWith(
      wrapper.vm.config.pasos.oferta.pasoSiguiente
    );
  });
});
